import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { style } from './login-to-order.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { BaseUrlController } from 'components/shared/enterprise-domains/base-url-controller.js'
import { HeadingSlotMixin } from 'components/shared/heading/heading-slot-mixin.js'
import { HiddenFieldsMixin } from 'components/shared/hidden-fields/hidden-fields-mixin.js'

export const loginToOrderHiddenFields = ['description', 'login-button', 'register-button'] as const

export const buttonVariants = ['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning'] as const
export type buttonVariantsType = typeof buttonVariants

initializeIconsByRole({
  'csc-login-to-order.user': { name: 'user', style: 'light' }
})

@customElement('csc-login-to-order')
export class CSCLoginToOrder extends HiddenFieldsMixin(HeadingSlotMixin(LitElement), loginToOrderHiddenFields) {
  static override styles: CSSResultGroup = [hostStyle, style]

  private urls = new BaseUrlController(this)

  @property({ type: String, attribute: 'login-button-variant' })
  loginButtonVariant: buttonVariantsType[number] = 'primary'

  @property({ type: String, attribute: 'register-button-variant' })
  registerButtonVariant: buttonVariantsType[number] = 'default'

  private openLoginSidebar() {
    const sidebarElement = document.querySelector('#login-sidebar')
    sidebarElement && sidebarElement.dispatchEvent(new CustomEvent('openSidebar', { bubbles: true, composed: true }))
  }

  private get hasVisibleContent() {
    return (
      this.hasHeading ||
      !this.isHidden('description') ||
      !this.isHidden('login-button') ||
      !this.isHidden('register-button')
    )
  }

  override render() {
    if (!this.hasVisibleContent) return this.renderHeadingSlot()

    return html`
      <div class="login-to-order">
        ${this.renderHeadingSlot()}
        ${
        !this.isHidden('description')
          ? html` <cse-text as="p">
              ${t('text', { ns: 'csc-login-to-order', default: 'Prices are only visible when logged in. When not logged in, you can still browse our assortment and get inspired. Not a customer yet? Please register.' })}
            </cse-text>`
          : nothing
      }
        ${
        !this.isHidden('login-button') || !this.isHidden('register-button')
          ? html` <div class="login-to-order__actions">
              ${
            !this.isHidden('login-button')
              ? html` <cse-button variant=${this.loginButtonVariant} @click=${this.openLoginSidebar}>
                  <cse-icon icon-role="csc-login-to-order.user"></cse-icon>
                  ${t('login_button', { ns: 'csc-login-to-order', default: 'Login to see prices' })}
                </cse-button>`
              : nothing
          }
              ${
            !this.isHidden('register-button')
              ? html` <cse-button variant=${this.registerButtonVariant} url=${this.urls.href('account/registration/')}>
                  ${t('register_button', { ns: 'csc-login-to-order', default: 'Register' })}
                </cse-button>`
              : nothing
          }
            </div>`
          : nothing
      }
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-login-to-order': CSCLoginToOrder
  }
}
